import { useFeature } from '@monofront/business/contexts';

import React, { createContext, useContext, useEffect, useState } from 'react';

interface IABTestEnabledProps {
  children: React.ReactNode;
  feature: string;
}

const IsFeatureOnContext = createContext<boolean>(false);

const Provider: React.FC<IABTestEnabledProps> = ({ children, feature }) => {
  const isFeatureOn = useFeature(feature).on;
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <IsFeatureOnContext.Provider value={isMounted && isFeatureOn}>
      {children}
    </IsFeatureOnContext.Provider>
  );
};

interface ITestRenderProps {
  children: React.ReactNode;
}

const A: React.FC<ITestRenderProps> = ({ children }) => {
  const isFeatureOn = useContext(IsFeatureOnContext);

  // microsoft/TypeScript#51328
  return isFeatureOn ? null : (children as React.ReactElement<any>);
};

const B: React.FC<ITestRenderProps> = ({ children }) => {
  const isFeatureOn = useContext(IsFeatureOnContext);

  // microsoft/TypeScript#51328
  return isFeatureOn ? (children as React.ReactElement<any>) : null;
};

export default { Provider, A, B };
